import React, { useState } from "react";
import { Row, Col } from "reactstrap";
import {
  GridComponent,
  Inject,
  ColumnDirective,
  ColumnsDirective,
  CommandColumn,
  Page,
  Filter,
  Toolbar,
  ExcelExport,
  Sort,
  Resize,
  Group,
  Freeze,
} from "@syncfusion/ej2-react-grids";
import { useIrnStore } from "../../../store/useIrnstore";

const AllPOGrid = ({}) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const { allPos } = useIrnStore();

  const handleQueryCellInfo = (args) => {
    if (args.column.field === "IRNStatus") {
      const value = args.data.IRNStatus;

      if (value === "Completed") {
        args.cell.style.color = "green";
        args.cell.style.fontWeight = "600";
      } else if (value === "Partial") {
        args.cell.style.color = "Orange";
        args.cell.style.fontWeight = "600";
      } else if (value === "Pending") {
        args.cell.style.color = "#B8860B";
        args.cell.style.fontWeight = "600";
      } else {
        args.cell.style.color = "#333";
      }
    }
  };
  const processedData = allPos.map((item) => ({
    ...item,
    PurchaseOrderDate: item.PurchaseOrderDate
      ? new Date(item.PurchaseOrderDate)
      : null,
    PoExpiryDate: item.PoExpiryDate ? new Date(item.PoExpiryDate) : null,
    UploadedOn: item.UploadedOn ? new Date(item.UploadedOn) : null,
  }));

  let gridInstance;
  const toolbarClick = (args) => {
    if (gridInstance && args.item.id === "BrokerGrid_excelexport") {
      gridInstance.excelExport();
    }
  };

  return (
    <>
      <div
        className={`grid_compact ${isMobile ? "e-bigger" : ""}`}
        style={{
          position: "relative",
          marginTop: "10px",
          background: "#fff",
          borderRadius: 12,
          boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
          padding: "6px",
          marginBottom: "20px",
        }}
      >
        <Row>
          <Col>
            <GridComponent
              ref={(g) => (gridInstance = g)}
              id="BrokerGrid"
              dataSource={processedData}
              allowPaging={true}
              allowSorting={true}
              allowFiltering={true}
              filterSettings={{ type: "Excel" }}
              toolbar={["ExcelExport", "Search"]}
              allowExcelExport={true}
              toolbarClick={toolbarClick}
              enableAdaptiveUI={isMobile}
              rowRenderingMode={isMobile ? "Vertical" : "Horizontal"}
              gridLines="Both"
              height={"300px"}
              pageSettings={{
                pageSizes: [10, 20, 30, 40, 50, "All"],
                pageCount: 10,
              }}
              rowHeight={isMobile ? "" : 32}
              queryCellInfo={handleQueryCellInfo}
              allowResizing={true}
              dataBound={() => {
                if (!isMobile && gridInstance) {
                  gridInstance.autoFitColumns();
                }
              }}
              // rowDataBound={()}
              // commandClick={handleCommandClick}
            >
              <ColumnsDirective>
                <ColumnDirective
                  field="serialNo"
                  headerText="S No"
                  textAlign="left"
                  width="70"
                  allowFiltering={false}
                />
                <ColumnDirective
                  field="StoreCode"
                  headerText="Store Code"
                  width="150"
                  textAlign="Left"
                  allowFiltering={false}
                />

                <ColumnDirective
                  field="Supplier"
                  headerText="Supplier"
                  width="150"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="SupplierName"
                  headerText="Supplier Name "
                  width="150"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="PurchaseOrder"
                  headerText="Purchase Order"
                  width="200"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="PurchaseOrderDate"
                  headerText="Purchase Order Date"
                  width="250"
                  textAlign="Left"
                  type="date"
                  format="dd/MM/yyyy"
                />
                <ColumnDirective
                  field="PoExpiryDate"
                  headerText="Po Expiry Date"
                  width="250"
                  textAlign="Left"
                  type="date"
                  format="dd/MM/yyyy"
                />
                <ColumnDirective
                  field="IRNStatus"
                  headerText="IRN Status"
                  width="250"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="POQty"
                  headerText="PO Qty"
                  width="150"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="POValue"
                  headerText="PO Value"
                  width="150"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="IRNQty"
                  headerText="IRN Qty"
                  width="150"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="IRNValue"
                  headerText="IRN Value"
                  width="150"
                  textAlign="Left"
                />
                <ColumnDirective
                  field="UploadedOn"
                  headerText="Uploaded On"
                  width="150"
                  textAlign="Left"
                  type="date"
                  format="dd/MM/yyyy"
                />
              </ColumnsDirective>

              <Inject
                services={[
                  CommandColumn,
                  Page,
                  Filter,
                  Toolbar,
                  ExcelExport,
                  Sort,
                  Group,
                  Resize,
                  Freeze,
                ]}
              />
            </GridComponent>
          </Col>
        </Row>
      </div>
    </>
  );
};

export default AllPOGrid;
